import useI18n from '@/locales/useI18n'

const { t } = useI18n()

export function getColumnTr(column: string) {
  if (column.startsWith('tag:')) {
    return column.slice(4)
  }

  switch (column) {
    case 'quantity':
    case 'qty':
      return t('quantity')
    case 'retailPrice':
      return t('retail')
    case 'wholesalePrice':
      return t('wholesale')
    case 'discountedPrice':
    case 'discountPrice':
      return t('discounted')
    default:
      return t(column)
  }
}